import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdatePostsMutation } from "../graphql/mutations";
import type {
  UpdatePostsMutationType,
  UpdatePostsMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdatePostsMutation = (
  options?: MutationHookOptions<
    UpdatePostsMutationType,
    UpdatePostsMutationVariablesType
  >
) => {
  return useMutation<UpdatePostsMutationType, UpdatePostsMutationVariablesType>(
    UpdatePostsMutation,
    options
  );
};
